import axios, { AxiosError } from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_PLANETDIET_API_URL;
axios.defaults.headers.post['Content-Type'] = 'text/json';

enum TimelineIcons {'note', 'vial', 'meal', 'house', 'Calendar'}

export type TaskType = {
    title: string         // Task title
    taskName: string      // Task name
    taskId: string        // Task id
    button: string        // Task button
    description: string // Task description
    dueOnDate: string    // Task due on date
    isCompleted: boolean // Task is completed
    completedDate?: string // ISO datetime of task completion
    participantId: string // Participant id
    popUpOverlay?: string // Task pop up overlay
    iconType: keyof typeof TimelineIcons
    dueOnDateEditable: boolean // Defines if the due date can be edited
}

export type TaskResponseType = {
    tasks: TaskType[]
}

const apiKey = process.env.REACT_APP_PLANETDIET_API_KEY;

export const TaskAPI = {
    getTasks: async (token: string): Promise<TaskResponseType> => {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Ocp-Apim-Subscription-Key': apiKey,
            };

            const response = await axios.get('/notification/tasks', { headers });

            return response.data;
        } catch (e: any) {
            return axiosError(e);
        }
    },
};

const axiosError = (error: AxiosError) => {
    throw new Error(`Axios Error: ${error.status} - ${(error.response?.data as any)?.message}`);
};